import { memo } from "react";
function TextArea(props) {
  return (
    <div>
      <label htmlFor="exampleFormControlTextarea1" className="form-label">
        {props.detail}
      </label>
      <textarea
        name={props.name}
        onChange={(e) => props.Change(e.target.value)}
        value={props.value ? props.value : ""}
        className="form-control"
        id="exampleFormControlTextarea1"
        rows={props.rows}
      ></textarea>
    </div>
  );
}

export default memo(TextArea);
